import { FadeIn } from "@/components/site/FadeIn";
import { AUTHOR, HUMMINGBIRD_STORY, BOOK } from "@/data/book";

export const Author = () => (
  <section
    id="author"
    data-testid="author-section"
    className="relative py-28 sm:py-36"
  >
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid lg:grid-cols-12 gap-14 items-start">
        {/* portrait */}
        <FadeIn className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-[#2a7b76]/10 blur-2xl" />
            <img
              data-testid="author-image"
              src={BOOK.authorImage}
              alt="Isaac Xavier"
              className="relative w-full rounded-[1.75rem] object-cover aspect-[4/5] ring-1 ring-stone-200 shadow-[0_20px_50px_-20px_rgba(32,28,25,0.35)]"
            />
          </div>
          <div className="mt-6">
            <span
              data-testid="author-neuromovement-badge"
              className="inline-block rounded-full bg-[#f5f2ea] border border-stone-200 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[#2a7b76] font-semibold"
            >
              40+ years in Neuro-Movement
            </span>
          </div>
        </FadeIn>

        {/* bio */}
        <div className="lg:col-span-7">
          <FadeIn>
            <p className="text-xs uppercase tracking-[0.28em] text-[#2a7b76] font-semibold mb-5">
              About the author
            </p>
            <h2 data-testid="author-name" className="font-display text-4xl sm:text-5xl text-[#201c19] font-light">
              {AUTHOR.name}
            </h2>
            <p data-testid="author-role" className="mt-3 text-[#c07a67] text-base font-medium tracking-wide">
              {AUTHOR.role}
            </p>
          </FadeIn>

          <FadeIn delay={0.12} className="mt-8 space-y-5" data-testid="author-bio-text">
            {AUTHOR.bio.map((p) => (
              <p key={p} className="text-lg text-stone-600 leading-relaxed font-light">
                {p}
              </p>
            ))}
          </FadeIn>

          <FadeIn delay={0.2} className="mt-12 rounded-2xl border-l-2 border-[#2a7b76] bg-[#f5f2ea]/60 p-8 sm:p-10">
            <h3 className="font-display text-3xl italic text-[#201c19] mb-6">
              {HUMMINGBIRD_STORY.heading}
            </h3>
            <div className="space-y-4">
              {HUMMINGBIRD_STORY.body.map((p) => (
                <p key={p} className="text-base text-stone-600 leading-relaxed font-light">
                  {p}
                </p>
              ))}
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  </section>
);

export default Author;
